/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import Entity from './entity.directive';
import {EntityTableController, AddEntityController} from './entity-table.controller';
import EntityDetailsSidenav from './entity-details-sidenav.directive';

export default angular.module('tektelic.table', [])
    .controller('EntityTableController', EntityTableController)
    .controller('AddEntityController', AddEntityController)
    .directive('tkEntity', Entity)
    .directive('tkEntityDetailsSidenav', EntityDetailsSidenav)
    .name;



// WEBPACK FOOTER //
// ./src/app/table/index.js